export default {"src":"/_next/static/media/fail.b52fd664.svg","height":208,"width":280,"blurWidth":0,"blurHeight":0};